// extracted by mini-css-extract-plugin
export var noPointer = "table-module--noPointer--61122";
export var pointer = "table-module--pointer--4fb88";
export var resizer = "table-module--resizer--ef5e4";
export var tableColumnCellWrapper = "table-module--tableColumnCellWrapper--d9ca4";
export var tableColumnCellWrapperDisabled = "table-module--tableColumnCellWrapperDisabled--5041a";
export var tableTitle = "table-module--table-title--47360";